import React from "react";
import { BriefcaseBusiness, CalendarCheck2, GraduationCap, LayoutDashboard, LogOut, UserCircle } from "lucide-react";
import type { PartnerTab } from "./partnerDashboardModel";

const navigation: Record<PartnerTab, { label: string; icon: React.ReactNode }> = {
    overview: { label: "Overview", icon: <LayoutDashboard size={18} /> },
    workshops: { label: "Workshops", icon: <GraduationCap size={18} /> },
    internships: { label: "Internships", icon: <BriefcaseBusiness size={18} /> },
    interviews: { label: "Mock Interviews", icon: <CalendarCheck2 size={18} /> },
    profile: { label: "Profile", icon: <UserCircle size={18} /> },
};

function NavButton({ tab, active, onSelect }: { tab: PartnerTab; active: boolean; onSelect: (tab: PartnerTab) => void }) {
    const item = navigation[tab];
    return <button type="button" aria-current={active ? "page" : undefined} onClick={() => onSelect(tab)} className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-bold transition ${active ? "bg-gradient-to-r from-[#075dcc] to-[#38aee8] text-white shadow-md shadow-blue-500/20" : "text-slate-600 hover:bg-blue-50 hover:text-blue-800"}`}><span className={active ? "text-white" : "text-blue-600"}>{item.icon}</span>{item.label}</button>;
}

export default function PartnerNavigation({ available, active, onSelect, onLogout }: { available: PartnerTab[]; active: PartnerTab; onSelect: (tab: PartnerTab) => void; onLogout: () => void }) {
    const primary = available.filter((tab) => tab !== "profile");
    return <nav aria-label="Partner sections" className="flex h-full min-h-0 flex-col">
        <div className="space-y-1 lg:min-h-0 lg:flex-1 lg:overflow-y-auto">{primary.map((tab) => <NavButton key={tab} tab={tab} active={active === tab} onSelect={onSelect} />)}</div>
        <div className="mt-3 space-y-1 border-t border-slate-200 pt-3">
            <NavButton tab="profile" active={active === "profile"} onSelect={onSelect} />
            <button type="button" onClick={onLogout} className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-bold text-slate-500 transition hover:bg-rose-50 hover:text-rose-700"><LogOut size={18} />Logout</button>
        </div>
    </nav>;
}
